import React from 'react';

export interface ServiceCardProps {
  num: string;
  headline: string;
  description: string;
  tags: string[];
  spec: { k: string; v: string }[];
  moreLabel?: string;
}

/**
 * Single service tier card for the Services horizontal stack.
 * Non-interactive in v1 — the "Read brief →" is decorative until per-tier
 * brief pages exist. Hover lift + magenta border come from
 * .ai-service-card:hover in ai.css.
 */
export const ServiceCard: React.FC<ServiceCardProps> = ({
  num, headline, description, tags, spec, moreLabel = 'Read brief →',
}) => (
  <article className="ai-service-card">
    <span className="ai-service-num">{num}</span>
    <h3 className="ai-service-h3">{headline}</h3>
    <p className="ai-service-desc">{description}</p>
    <div className="ai-service-tags">
      {tags.map(t => <span key={t}>{t}</span>)}
    </div>
    <div className="ai-service-spec">
      {spec.map(s => (
        <div key={s.k}>
          <div className="k">{s.k}</div>
          <div className="v">{s.v}</div>
        </div>
      ))}
    </div>
    <span className="ai-service-more">{moreLabel}</span>
  </article>
);

export default ServiceCard;
